var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.active
    ? _c(
        "div",
        {
          class: _vm.dialogClass,
          attrs: { "ciao-vue-dialog": "dialog", size: _vm.config.size }
        },
        [
          _c(
            "div",
            {
              attrs: { "ciao-vue-dialog": "close-button" },
              on: {
                click: function($event) {
                  _vm.close(true)
                }
              }
            },
            [_vm._v("\n    ×\n  ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            { class: _vm.config.style, attrs: { "ciao-vue-dialog": "title" } },
            [
              _c("span", [_vm._v(_vm._s(_vm.config.title))]),
              _vm._v(" "),
              _vm.loading ? _c("ComponentLoader") : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _vm.hasBody
            ? _c(
                "div",
                { attrs: { "ciao-vue-dialog": "body" } },
                [
                  _vm.config.content
                    ? _c("div", [_vm._v(_vm._s(_vm.config.content))])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.config.component
                    ? _c(_vm.config.component, {
                        tag: "component",
                        attrs: {
                          loading: _vm.loading,
                          meta: _vm.meta,
                          error: _vm.error,
                          data: _vm.data
                        },
                        on: {
                          setLoader: _vm.setLoader,
                          commitAccept: _vm.onAccept,
                          commitDismiss: _vm.onDismiss,
                          updateData: _vm.updateData
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.hasFooter
            ? _c("div", { attrs: { "ciao-vue-dialog": "footer" } }, [
                _vm.config.accept
                  ? _c(
                      "button",
                      {
                        staticClass: "btn",
                        class: "btn-" + _vm.config.accept.style,
                        on: { click: _vm.onAccept }
                      },
                      [
                        _vm._v(
                          "\n      " +
                            _vm._s(_vm.config.accept.label) +
                            "\n    "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.config.dismiss
                  ? _c(
                      "button",
                      {
                        staticClass: "btn",
                        class: "btn-" + _vm.config.dismiss.style,
                        on: { click: _vm.onDismiss }
                      },
                      [
                        _vm._v(
                          "\n      " +
                            _vm._s(_vm.config.dismiss.label) +
                            "\n    "
                        )
                      ]
                    )
                  : _vm._e()
              ])
            : _vm._e()
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3ed376a2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ed376a2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Components/Dialog/Dialog.vue
// module id = null
// module chunks = 